import React, { useState} from 'react';
import DashboardHeader from '../include/DashboardHeader';
import DashboardSidebar from '../include/DashboardSidebar';
import DashboardTitle from './dashboard_modules/DashboardTitle';
import {Row, Col, Form, Button, Container} from 'react-bootstrap'
import { ErrorMessage, Field, Formik } from 'formik';
import {changePassword, OtpSchema, resetPassword} from './commonValidation';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify'
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import useAxiosInstance from '../../Api/AxiosInstance';
import {Link, useLocation, useNavigate} from "react-router-dom";
import logo from "../../assets/images/site-logo-yellow.png";
import register_img from "../../assets/images/register-img.png";



function ChangePassword() {
    const location = useLocation();
    const user = JSON.parse(localStorage.getItem("user"));
    const [error, setError] = useState('')
    const [confirmpasswordType, setconfirmpasswordType] = useState("password");
    const [newpasswordType, setNewpasswordType] = useState("password");
    const AxiosInstance = useAxiosInstance()
    const navigate = useNavigate();
    const userId = location.state?.user_id;
    console.log('User_id===='+userId);
    const togglePassword = (id) => {
        if (id == "confirmpassword")  {
            if (confirmpasswordType === "password") {
                setconfirmpasswordType("text");
                return true;
            }
            setconfirmpasswordType("password");
            return true;
        } else {
            if (newpasswordType === "password") {
                setNewpasswordType("text");
                return true;
            }
            setNewpasswordType("password");
            return true;
        }

    };



    const handleSubmit = async (values, { setSubmitting }) => {
        try {

            const response = await AxiosInstance.post( 'reset-password', values)
            if (response.data.success == "1") {
                toast.success('Password Update Successfully', {
                    position: "top-right",
                    autoClose: 1000,
                });
                navigate('/');
            }

        } catch (error) {
            setError(error.response.data.message)

        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className='main-page bg4'>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <section className='login-section'>
                <div className='circle-top-left'></div>
                <div className='circle-bottom-left'></div>
                <div className='pattern-top-center'></div>
                <div className='pattern-top-right'></div>
                <div className='pattern-bottom-right'></div>
                <Container className='relative'>
                    <Row className='login-inner v-center ptb-100'>
                        <Col xs={12} md={12} lg={6} className='left-block'>
                            <div className='login-img-wrapper'>
                                <div className='logo-block text-center ptb-30 pt-0'>
                                    <img src={logo} alt='' />
                                </div>
                                <div className='login-imgbox'>
                                    <img src={register_img} alt='' />
                                </div>
                                <div className='glow-box'></div>
                            </div>
                        </Col>

                        <Col xs={12} md={12} lg={6} className='right-block d-flex'>
                            <div className='form-wrapper ml-auto mr-auto'>
                                <div className='logo-block text-center ptb-30 hide show_mobi_view'>
                                    <img src={logo} alt='' />
                                </div>
                                <h2 className='tl'>Reset Password</h2>

                                <Formik
                                    initialValues={{
                                        is_reset_password:1,
                                        password: '',
                                        confirm_password: '',
                                        user_id: userId || ''
                                    }}
                                    validationSchema={resetPassword}
                                    onSubmit={handleSubmit}
                                >
                                    {({ handleSubmit, handleChange, values, isSubmitting }) => (
                                        <Form onSubmit={handleSubmit} >
                                            <div className='form-inner d-flex flex-column w-100'>

                                                <Form.Group className='input-field full-width'>
                                                    <label className='label'>New Password</label>
                                                    <div className="input-icon-block relative">
                                                        <Field name='password' type={newpasswordType} value={values.password} onChange={handleChange} placeholder='Enter Password' onInput={(e) => { e.target.value = e.target.value.slice(0, 20); }} />
                                                        <ErrorMessage name="password" >
                                                            {msg => (
                                                                <p className="mt-2" style={{ color: "red" }}>{msg}</p>
                                                            )}
                                                        </ErrorMessage>
                                                        <div className="ped-inn" onClick={() => togglePassword("newpassword")}>
                                                            {newpasswordType === "password" ? (
                                                                <AiOutlineEye />

                                                            ) : (
                                                                <AiOutlineEyeInvisible />
                                                            )}
                                                        </div>
                                                    </div>

                                                </Form.Group>

                                                <Form.Group className='input-field full-width'>
                                                    <label className='label'>Confirm New Password</label>
                                                    <div className="input-icon-block relative">
                                                        <Field name='confirm_password' type={confirmpasswordType} value={values.confirm_password} onChange={handleChange} placeholder='Enter Confirm Password' onInput={(e) => { e.target.value = e.target.value.slice(0, 20); }} />
                                                        <ErrorMessage name="confirm_password" >
                                                            {msg => (
                                                                <p className="mt-2" style={{ color: "red" }}>{msg}</p>
                                                            )}
                                                        </ErrorMessage>
                                                        <div className="ped-inn" onClick={() => togglePassword("confirmpassword")}>
                                                            {confirmpasswordType === "password" ? (
                                                                <AiOutlineEye />

                                                            ) : (
                                                                <AiOutlineEyeInvisible />
                                                            )}
                                                        </div>
                                                    </div>
                                                </Form.Group>

                                                <Form.Group className='input-field full-width form-btnbox mb-0'>
                                                    <Button className='btn secondary w-100' variant="primary" type="submit">Reset Password</Button>
                                                </Form.Group>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>

                                <div className='or-devider'><span>OR</span></div>
                                <div className='link-box'>
                                    <p>You have an account? <Link to='/'>Login to your account</Link></p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    )
}


export default ChangePassword